import { useCallback, useEffect, useState } from "react";
import { AuthControllerService, EntityModelGrantAndFunctionDto } from "openapi";
import authorizedCall from "features/common/utils/authorizedCall";
import { useAuth } from "react-oidc-context";

export const useUserGrants = () => {
  const [userGrants, setUserGrants] =
    useState<EntityModelGrantAndFunctionDto[]>();
  const [userGrantsIsFetching, setUserGrantsIsFetching] = useState(false);
  const [userGrantsError, setUserGrantsError] = useState("");

  const { isAuthenticated } = useAuth();

  const getUserGrants = useCallback(() => {
    if (isAuthenticated) {
      setUserGrantsError("");
      setUserGrantsIsFetching(true);
      authorizedCall(AuthControllerService.getGrantsAndFunctions, {})
        .then((data: EntityModelGrantAndFunctionDto[]) => {
          setUserGrantsIsFetching(false);
          setUserGrants(data);
        })
        .catch((error) => {
          console.error(error);
          setUserGrantsIsFetching(false);
          setUserGrantsError(error?.body?.message || error?.message);
        })
    }
  }, [isAuthenticated]);

  useEffect(() => {
    getUserGrants();
  }, [getUserGrants]);

  return {
    userGrants,
    userGrantsIsFetching,
    userGrantsError,
    getUserGrants,
  };
};
